import { combineReducers } from 'redux';
import appLink, { defaultState as appLinkDefaultState } from './applink/reducer.tsx';
import appLinks, { defaultState as appLinksDefaultState } from './applinks/reducer.tsx';
import articles, { defaultState as articlesDefaultState } from './articles/reducer.tsx';
import browse, { defaultState as browseDefaultState } from './browse/reducer.tsx';
import categories, { defaultState as categoriesDefaultState } from './categories/reducer.tsx';
import hub, { defaultState as hubDefaultState } from './hub/reducer.tsx';
import spaces, { defaultState as spacesDefaultState } from './spaces/reducer.tsx';

export default combineReducers({
	hub,
	articles,
	browse,
	categories,
	spaces,
	appLink,
	appLinks,
});

export const defaultState = {
	hub: hubDefaultState,
	articles: articlesDefaultState,
	browse: browseDefaultState,
	categories: categoriesDefaultState,
	spaces: spacesDefaultState,
	appLink: appLinkDefaultState,
	appLinks: appLinksDefaultState,
} as const;
